import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/exams/[examId]/[tab]/ExamPageComponent.tsx");
